import { render, staticRenderFns } from "./IntegralDetail.vue?vue&type=template&id=47369de2&scoped=true&"
import script from "./IntegralDetail.vue?vue&type=script&lang=js&"
export * from "./IntegralDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntegralDetail.vue?vue&type=style&index=0&id=47369de2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47369de2",
  null
  
)

export default component.exports